import cookieIcon from "@/assets/cookie-icon.svg";

const Footer = () => {
  const footerLinks = [
    { label: "Datenschutz", href: "/legal/datenschutz" },
    { label: "Barrierefreiheitserklärung", href: "/legal/barrierefreiheit" },
    { label: "Impressum", href: "/legal/impressum" },
    { label: "Nutzungsbedingungen", href: "/legal/nutzungsbedingungen" },
    { label: "Teilnahmebedingungen Treueprogramm", href: "/legal/teilnahmebedingungen-treueprogramm" }
  ];

  return (
    <>
      {/* Main Footer */}
      <div className="bg-[#d02615]">
        {/* Footer Links */}
        <div className="px-6 lg:px-6 pt-5 lg:pt-6">
          {/* Mobile: Vertical layout */}
          <div className="flex flex-col lg:hidden items-center gap-3">
            {footerLinks.map((link, index) => (
              <a
                key={index}
                href={link.href}
                className="font-['Futura'] font-medium text-[14px] text-white uppercase hover:opacity-80 transition-opacity leading-[1.2]"
              >
                {link.label}
              </a>
            ))}
          </div>

          {/* Desktop: Horizontal layout */}
          <div className="hidden lg:flex items-center justify-between w-full max-w-[1871px] mx-auto">
            <div className="flex items-center justify-between flex-1 mr-4">
              {footerLinks.map((link, index) => (
                <a
                  key={index}
                  href={link.href}
                  className="font-['Futura'] font-medium text-[14px] xl:text-[16px] text-white uppercase hover:opacity-80 transition-opacity leading-[1.2]"
                >
                  {link.label}
                </a>
              ))}
            </div>

            {/* Cookie Button */}
            <button
              type="button"
              className="bg-white rounded-[6px] w-[30px] h-[30px] flex items-center justify-center hover:opacity-90 transition-opacity cursor-pointer"
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                if (typeof window !== "undefined") {
                  const maybeOneTrust = window.OneTrust;
                  if (maybeOneTrust && typeof maybeOneTrust.ToggleInfoDisplay === "function") {
                    maybeOneTrust.ToggleInfoDisplay();
                    return;
                  }
                  const maybeOptanon = window.Optanon;
                  if (maybeOptanon && typeof maybeOptanon.ToggleInfoDisplay === "function") {
                    maybeOptanon.ToggleInfoDisplay();
                  }
                }
              }}
            >
              <img src={cookieIcon} alt="Cookie Settings" className="w-[30px] h-[30px]" />
            </button>
          </div>
        </div>

        {/* Copyright and Disclaimers */}
        <div className="px-6 py-4 md:py-5 pb-25 md:pb-32">
          {/* Mobile */}
          <div className="flex lg:hidden flex-col items-center gap-4">
            <div className="flex items-center justify-between w-full">
              <p className="font-['Arial'] text-[12px] text-white leading-[1.2]">
                © British American Tobacco AG<br />
                All Rights Reserved.
              </p>
              <button
                type="button"
                className="bg-white rounded-[6px] w-[30px] h-[30px] flex items-center justify-center hover:opacity-90 transition-opacity"
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  if (typeof window !== "undefined") {
                    const maybeOneTrust = window.OneTrust;
                    if (maybeOneTrust && typeof maybeOneTrust.ToggleInfoDisplay === "function") {
                      maybeOneTrust.ToggleInfoDisplay();
                      return;
                    }
                    const maybeOptanon = window.Optanon;
                    if (maybeOptanon && typeof maybeOptanon.ToggleInfoDisplay === "function") {
                      maybeOptanon.ToggleInfoDisplay();
                    }
                  }
                }}
              >
                <img src={cookieIcon} alt="Cookie Settings" className="w-[30px] h-[30px]" />
              </button>
            </div>
          </div>

          {/* Desktop */}
          <div className="hidden lg:flex items-end justify-between w-full max-w-[1871px] mx-auto">
            <p className="font-['Futura'] font-medium text-[14px] text-white">
              © British American Tobacco (Germany) GmbH. All Rights Reserved.
            </p>
            <div className="font-['Futura'] font-medium text-[14px] text-white text-right">
              <p>*Nur Raucher/innen über 18 Jahren mit Wohnsitz in Deutschland</p>
              <p>**Nur solange der Vorrat reicht</p>
            </div>
          </div>
        </div>
      </div>

      {/* Health Warning Banner - Fixed at bottom */}
      <div className="fixed bottom-0 left-0 right-0 z-[101] bg-[var(--yellow)] flex flex-col">
        {/* Top disclaimer line */}
        <div className="bg-[var(--yellow)] border-b border-black py-1 md:py-1.5 lg:py-2 flex items-center justify-center h-[23px] md:h-[22px] lg:h-[31px]">
          <p className="font-extrabold text-[7px] md:text-[10px] lg:text-[14px] text-black uppercase text-center">
            Tabak ohne Zusätze bedeutet nicht, dass es sich um eine risikoärmere Zigarette handelt.
          </p>
        </div>
        {/* Main health warning */}
        <div className="bg-[var(--yellow)] flex items-center justify-center h-[45px] md:h-[53px] lg:h-[77px]">
          <p className="font-extrabold text-[26px] md:text-[40px] lg:text-[52px] text-black uppercase">
            Rauchen IST tödlich.
          </p>
        </div>
      </div>
    </>
  );
};

export default Footer;
